import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { JurisdiccionSarlaft, ScoreSarlaft, VariablesSarlaft } from '../_models/sarlaft-modal-simulador';
import { Variable } from '../_models/variable-sarlaft';

@Injectable({
  providedIn: 'root'
})
export class SarlaftSimuladorService {

  private rutServicioVariables = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariables';
  private rutServicio = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftNiveles';
  private rutServicioBuscador = AppSettings.rutServiciosRG + '/api/divisionPolitica/descripcion/start/divisionPoliticaTipo/code/2/cantidad10/enabled';
  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  obtenerVariablesSarlaft() {
    return this.httpClient.get( this.rutServicioVariables + '/enabled' ).pipe( map( res => res as Variable[] ) );
  }
  obtenerScoreSarlaft( valor: number ) {
    return this.httpClient.get( this.rutServicio + '/rango/' + valor + '/enabled' ).pipe( map( res => res as ScoreSarlaft ) );
  }

  burcadorVariableJurisdiccion( data: string ) {
    return this.httpClient.post( this.rutServicioBuscador, data ).pipe( map( res => res as JurisdiccionSarlaft[] ) );
  }
  validarScore( idTipoProcesoCredito: string, score: any ) {
    return this.httpClient.get( `${this.rutServicio}/tipoProcesoCredito/${idTipoProcesoCredito}/rango/${score}/enabled`).pipe( map( res => res as any ) );
  }

  validarDesicionSarlaft(idSolicitudUC: string) {
    return this.httpClient.get( `${this.rutServicio}/validarDecisionSarlaft/solicitudUC/${idSolicitudUC}/usuario/${this.autServicio.obtenerIdUsuarioLogueado()}`).pipe( map( res => res as any ) );
  }

  validarEstadoBloqueoSarlaft( idSolicitudUC: string ) {
    return this.httpClient.get( `${this.rutServicio}/solicitudUC/${idSolicitudUC}/validarEstadoBloqueado/cambioEstado/usuario/${this.autServicio.obtenerIdUsuarioLogueado()}`).pipe( map( res => res as any ));
  }

}
